import { useLocation } from 'react-router-dom';

export function useQuerySearch() {
  const location = useLocation();
  return new URLSearchParams(location.search);
}
